import axios from "axios";
import { LocalStorageService } from "./LocalStorageService";

const api = axios.create({
    baseURL: process.env.REACT_APP_ROUTE_API,
});

export class LoginService {
    async logIn(e) {
        const payload = {
            usuario: e.user,
            contrasenia: e.password,
            plataforma: 'admin'
        };
        return api.post("/login", payload).then((res) => res.data);
    }

    async refreshToken() {
        const refreshToken = new LocalStorageService().getRefreshToken();
        return api.post("/login/refresh", { refreshToken }).then((res) => res.data);
    }

    async cerrarSesion() {
        const refreshToken = new LocalStorageService().getRefreshToken();
        return api.post("/login/logout", { refreshToken }).then((res) => res.data);
    }
}
